<template>
  <footer class="footer footer-center p-4 text-sm text-base-content/60 gap-1">
    <div class="flex flex-wrap items-center justify-center gap-2">
      <router-link to="/mentions-legales" class="link link-hover">Mentions légales</router-link>
      <span class="opacity-50">·</span>
      <router-link to="/confidentialite" class="link link-hover">Confidentialité</router-link>
      <span class="opacity-50">·</span>
      <router-link to="/cgu" class="link link-hover">CGU</router-link>
      <span class="opacity-50">·</span>
      <router-link to="/cgv" class="link link-hover">CGV</router-link>
    </div>
    <p>© {{ year }} Langochat - SBC LABS</p>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear()
</script>
